// extracted by mini-css-extract-plugin
module.exports = {"phrase_container":"styles_phrase_container__2vvwd","phrase_author":"styles_phrase_author__3Wyel","text-msj":"styles_text-msj__1zAZq","space":"styles_space___smow"};